import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const requestClose = createAction(`${actionKey}.REQUEST_CLOSE`, ()=>({}));
export const fetchCollections = createAction(`${actionKey}.FETCH`, ()=>({}));
export const initializeDeviation = createAction(`${actionKey}.INITIALIZE_DEVIATION`, (deviationId, faveCount, noPreselectedFeatured, ignorePreselectedCollections)=>({
        deviationId,
        faveCount,
        noPreselectedFeatured,
        ignorePreselectedCollections
    }));
export const initializeDeviationCollections = (deviationId, collectionids, faveCount, noPreselectedFeatured = false, ignorePreselectedCollections = false)=>initializeDeviationCollectionsCustom(deviationId, {
        collectionids,
        faveCount,
        noPreselectedFeatured,
        ignorePreselectedCollections
    });
export const initializeDeviationCollectionsCustom = createAction(`${actionKey}.INITIALIZE_DEVIATION_COLLECTIONS`, (deviationId, options)=>_object_spread({
        deviationId
    }, options));
export const toggleCollection = createAction(`${actionKey}.TOGGLE_COLLECTION`, (folderId, deviationId)=>({
        folderId,
        deviationId
    }));
export const undoChanges = createAction(`${actionKey}.UNDO`, (deviationId)=>({
        deviationId
    }));
export const commitCollections = createAction(`${actionKey}.COMMIT_COLLECTIONS`, (deviation)=>({
        deviation,
        notificationQueue: 'default'
    }));
export const commitCollectionsCustom = createAction(`${actionKey}.COMMIT_COLLECTIONS`, (deviation, notificationQueue)=>({
        deviation,
        notificationQueue
    }));
export const commitCollectionsSuccess = createAction(`${actionKey}.COMMIT_COLLECTIONS.SUCCESS`, (folderIds, deviationId, entities)=>({
        folderIds,
        deviationId,
        entities
    }));
export const commitCollectionsFail = createAction(`${actionKey}.COMMIT_COLLECTIONS.FAIL`, (folderIds, deviationId)=>({
        folderIds,
        deviationId
    }));
export const createCollection = createAction(`${actionKey}.CREATE_COLLECTION`, (name, selectDeviationId)=>({
        name,
        selectDeviationId
    }));
export const createCollectionSuccess = createAction(`${actionKey}.CREATE_COLLECTION.SUCCESS`, (folderId, entities)=>({
        folderId,
        entities
    }));
export const createCollectionFail = createAction(`${actionKey}.CREATE_COLLECTION.FAIL`, (name)=>({
        name
    }));
export const changeFave = createAction(`${actionKey}.CHANGE_FAVE`, (deviation, to)=>({
        deviation,
        to,
        notificationQueue: 'default'
    }));
export const changeFaveCustom = createAction(`${actionKey}.CHANGE_FAVE`, (deviation, to, notificationQueue)=>({
        deviation,
        to,
        notificationQueue
    }));
export const changeFaveSuccess = createAction(`${actionKey}.CHANGE_FAVE.SUCCESS`, (deviationId, to)=>({
        deviationId,
        to
    }));
export const changeFaveFail = createAction(`${actionKey}.CHANGE_FAVE.FAIL`, (deviationId)=>({
        deviationId
    }));
export const collectFave = createAction(`${actionKey}.COLLECTFAVE`, (deviation, notificationQueue, actionBarType)=>({
        deviation,
        notificationQueue,
        actionBarType
    }));
export const setFaveState = createAction(`${actionKey}.SET_FAVE`, (deviation, to)=>({
        deviation,
        to
    }));
export const resetJustFaved = createAction(`${actionKey}.RESET_JUST_FAVED`, (deviationId)=>({
        deviationId
    }));
